__turbopack_context__.v({
  "chevron": "Banner-module-scss-module__ptMg4W__chevron",
  "container": "Banner-module-scss-module__ptMg4W__container",
  "content": "Banner-module-scss-module__ptMg4W__content",
  "contentCenter": "Banner-module-scss-module__ptMg4W__contentCenter",
  "contentLeft": "Banner-module-scss-module__ptMg4W__contentLeft",
  "contentRight": "Banner-module-scss-module__ptMg4W__contentRight",
  "cta": "Banner-module-scss-module__ptMg4W__cta",
  "ctaButton": "Banner-module-scss-module__ptMg4W__ctaButton",
  "ctaLink": "Banner-module-scss-module__ptMg4W__ctaLink",
  "darkText": "Banner-module-scss-module__ptMg4W__darkText",
  "image": "Banner-module-scss-module__ptMg4W__image",
  "imageContainer": "Banner-module-scss-module__ptMg4W__imageContainer",
  "lightText": "Banner-module-scss-module__ptMg4W__lightText",
  "section": "Banner-module-scss-module__ptMg4W__section",
  "text": "Banner-module-scss-module__ptMg4W__text",
  "wrapper": "Banner-module-scss-module__ptMg4W__wrapper",
  "wrapperReverse": "Banner-module-scss-module__ptMg4W__wrapperReverse",
});
